export const SALON_POLICIES = [
  {
    id: "arrival",
    title: "Arrival Policy & Guest Policy",
    content:
      "Please try your best to arrive on time. There is 15min grace period, after 15mins there is a $15 min late fee. After 25 mins the appointment will be cancelled and need to be rescheduled. No extra guest allowed.",
  },
  {
    id: "cancellation",
    title: "Cancellations & No-Shows",
    content:
      "Appointments cancelled within 48hours of appointment will have to pay a new deposit to reschedule.",
  },
  {
    id: "squeeze-ins",
    title: "Squeeze Ins",
    content:
      "Squeeze ins/Same day $40\nNO EXTRA GUEST UNDER NO CIRCUMSTANCE UNLESS DISCUSSED BEFOREHAND.",
  },
  {
    id: "payments",
    title: "Payments",
    content:
      "A $20 non-refundable deposit is required to secure your appointment. The remaining balance is due at the end of the service. Accepted payment methods include Zelle, Tap to Pay, Apple Pay, and Cash App. Cash payments are accepted as a last resort.",
  },
  {
    id: "security",
    title: "Security & Privacy Policy",
    content:
      "Your privacy is important to me. Any personal information collected during booking or consultation is used solely for providing my services and communication.\n\nI do not sell, trade, or share your personal information with third parties.\n\nPhotos taken during your appointment will only be used for portfolio purposes with your explicit consent.\n\nPayment information is processed securely and is not stored on my systems.",
  },
  {
    id: "hair-prep",
    title: "Hair Preparation Policy",
    content:
      "- For wig installs, hair must be dropped off 2-3 days before.\n- Natural hair should be detangled.\n- All services come with a wash and a blow dry.",
  },
];
